import React from 'react';
import { useTranslation } from 'react-i18next';

const AboutSection = () => {
  const { t } = useTranslation('common');

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: t('security'),
      description: t('securityDesc')
    },
    {
      icon: 'ri-time-line',
      title: t('punctuality'),
      description: t('punctualityDesc')
    },
    {
      icon: 'ri-heart-line',
      title: t('hospitality'),
      description: t('hospitalityDesc')
    },
    {
      icon: 'ri-star-line',
      title: t('excellence'),
      description: t('excellenceDesc')
    }
  ];

  return (
    <section id="a-propos" className="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          {/* Contenu texte */}
          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-charcoal-800 mb-4 sm:mb-6">
              {t('aboutTitle')}
            </h2>
            <p className="text-base sm:text-lg text-charcoal-600 mb-4 sm:mb-6 leading-relaxed">
              {t('aboutDescription1')}
            </p>
            <p className="text-base sm:text-lg text-charcoal-600 mb-6 sm:mb-8 leading-relaxed">
              {t('aboutDescription2')}
            </p>

            {/* Valeurs */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {values.map((value, index) => (
                <div key={index} className="flex items-start space-x-3 sm:space-x-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gold-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${value.icon} text-gold-600 text-lg sm:text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-charcoal-800 mb-1 sm:mb-2 text-sm sm:text-base">{value.title}</h3>
                    <p className="text-xs sm:text-sm text-charcoal-600 leading-relaxed">{value.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Images */}
          <div className="relative mt-8 lg:mt-0">
            <div className="grid grid-cols-2 gap-3 sm:gap-4">
              <div className="space-y-3 sm:space-y-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=Documentary%20photography%20of%20real%20Atlas%20Mountains%20Morocco%20taken%20by%20National%20Geographic%20photographer%2C%20authentic%20mountain%20landscape%20with%20genuine%20Berber%20villages%2C%20unfiltered%20natural%20scenery%2C%20realistic%20mountain%20photography%2C%20actual%20traditional%20architecture%20in%20mountain%20setting%2C%20professional%20travel%20documentation&width=300&height=400&seq=documentary-atlas-mountains&orientation=portrait"
                  alt="Montagnes de l'Atlas"
                  className="w-full h-48 sm:h-56 md:h-64 object-cover object-top rounded-lg shadow-lg"
                />
                <img 
                  src="https://readdy.ai/api/search-image?query=Street%20photography%20by%20professional%20photojournalist%20in%20real%20Moroccan%20medina%2C%20authentic%20marketplace%20with%20actual%20local%20vendors%2C%20genuine%20cultural%20documentation%20without%20staging%2C%20natural%20lighting%20in%20traditional%20souk%2C%20realistic%20documentary%20photography%20of%20daily%20life%20in%20Morocco%2C%20unposed%20authentic%20scene&width=300&height=200&seq=photojournalist-medina&orientation=landscape"
                  alt="Rues de la médina"
                  className="w-full h-32 sm:h-36 md:h-40 object-cover object-top rounded-lg shadow-lg"
                />
              </div>
              <div className="space-y-3 sm:space-y-4 mt-6 sm:mt-8">
                <img 
                  src="https://readdy.ai/api/search-image?query=Magnificent%20traditional%20Moroccan%20architecture%20with%20intricate%20geometric%20patterns%2C%20beautiful%20Islamic%20design%20details%2C%20ornate%20doorways%20and%20arches%2C%20authentic%20Moroccan%20craftsmanship%2C%20warm%20golden%20lighting%2C%20no%20people%20visible%2C%20architectural%20photography%20showcasing%20cultural%20heritage&width=300&height=400&seq=morocco-architecture-heritage&orientation=portrait"
                  alt="Architecture marocaine traditionnelle"
                  className="w-full h-48 sm:h-56 md:h-64 object-cover object-top rounded-lg shadow-lg"
                />
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20travel%20photography%20by%20renowned%20photographer%20of%20actual%20Sahara%20desert%20Morocco%2C%20authentic%20desert%20expedition%20with%20real%20camel%20guides%2C%20genuine%20nomadic%20culture%20documentation%2C%20natural%20desert%20landscape%20without%20enhancement%2C%20realistic%20travel%20journalism%20photography%2C%20actual%20desert%20tourism%20scene%20with%20actual%20desert%20guides&width=300&height=200&seq=professional-sahara-expedition&orientation=landscape"
                  alt="Oasis du désert marocain"
                  className="w-full h-32 sm:h-36 md:h-40 object-cover object-top rounded-lg shadow-lg"
                />
              </div>
            </div>
            
            {/* Badge de certification */}
            <div className="absolute -bottom-4 -left-4 sm:-bottom-6 sm:-left-6 bg-blue-600 text-white p-4 sm:p-6 rounded-lg shadow-xl">
              <div className="text-center">
                <div className="text-xl sm:text-2xl font-bold">10+</div>
                <div className="text-xs sm:text-sm">{t('yearsExperience')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
